export default {"src":"/_next/static/media/ic-survey_completed.1e3c2387.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};